/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import EnvironmentService from 'cio/services/environment';
import { inject as service } from '@ember/service';
import { Highlight, HighlightLink, HighlightRoute } from 'cio/components/plan-info/plan-highlights';

interface ItemArgs {
  highlight: Highlight;
}

export default class Item extends Component<ItemArgs> {
  @service environment!: EnvironmentService;

  get hasLink() {
    return (this.args.highlight as HighlightLink)?.href != null;
  }

  get hasRoute() {
    return (this.args.highlight as HighlightRoute)?.route != null;
  }

  get environmentId() {
    return this.environment.lastEnvironmentId;
  }
}
